import { render, staticRenderFns } from "./TCDImpayes.vue?vue&type=template&id=6cc479a7&scoped=true"
import script from "./TCDImpayes.vue?vue&type=script&lang=js"
export * from "./TCDImpayes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc479a7",
  null
  
)

export default component.exports